import { render, staticRenderFns } from "./SquadCard.vue?vue&type=template&id=e8a75eb0"
import script from "./SquadCard.vue?vue&type=script&lang=js"
export * from "./SquadCard.vue?vue&type=script&lang=js"
import style0 from "./SquadCard.vue?vue&type=style&index=0&id=e8a75eb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports